import AprCalculator from '../components/AprCalculator';
import { defineCalculator } from './defineCalculator';

defineCalculator('scl-apr-calculator', AprCalculator);
